import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SubjectLetterService } from 'src/app/Service/SubjectLetter/SubjectLetter.service';

@Component({
  selector: 'app-SubjectLetterEdit',
  templateUrl: './SubjectLetterEdit.component.html',
  styleUrls: ['./SubjectLetterEdit.component.scss']
})
export class SubjectLetterEditComponent implements OnInit {
  EditRecord:Number

  constructor(
    private SubjectLetter_Service:SubjectLetterService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.EditSubjectLetter=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(-1).subscribe(
      data=>{
        this.SubjectLetter_Service.GetSingle(this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)

          }
        )
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

    //#region  Form Add

    EditSubjectLetter:FormGroup;

    get_Form_Id(){
      return this.EditSubjectLetter.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditSubjectLetter.get('Title') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditSubjectLetter(){
      var Record:General_Interface =Empty_General_Interface()
      Record.id=this.get_Form_Id().value
      Record.title=this.get_Form_Title().value
      this.InProccessing=true
      this.SubjectLetter_Service.EditSubject_Letter(Record).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
          }
          else{

            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }
      )
    }



}
